import React, { useState, useEffect } from 'react'
import { TextField, Grid, Typography } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import Button from 'components/common/Button'
import axios from 'axios'
import { useConfig } from 'hooks/useConfig'

const SandDriveReviewApp = ({ handleClose, onConfigUpdate }) => {
  const { config } = useConfig()
  const [input, setInput] = useState('')
  const [currentReviewApp, setCurrentReviewApp] = useState(null)
  const [loading, setLoading] = useState(false)

  const previewUrl = /^\d+$/.test(input.trim())
    ? `https://${input.trim()}.review.tssands.com/`
    : input

  useEffect(() => {
    axios
      .get(`${config.LOGITRAC_API_URL}api/config/sanddrive-review-app`)
      .then(response => {
        setCurrentReviewApp(response.data)
        if (response.data?.url) {
          const match = response.data.url.match(/https:\/\/(\d+)\.review\.tssands\.com\//)
          setInput(match ? match[1] : response.data.url)
        }
      })
      .catch(error => {
        console.error('Failed to fetch current review app:', error)
      })
  }, [config.LOGITRAC_API_URL])

  const handleSubmit = async () => {
    if (!input) {
      return
    }

    setLoading(true)
    try {
      await axios.post(
        `${config.LOGITRAC_API_URL}api/config/sanddrive-review-app`, 
        { url: input }
      )
      // Call the callback to update the banner
      if (onConfigUpdate) {
        onConfigUpdate()
      }
      handleClose()
    } catch (error) {
      console.error('Failed to set review app:', error)
      console.error('Failed to set SandDrive URL')
    } finally {
      setLoading(false)
    }
  }

  const handleClear = async () => {
    setLoading(true)
    try {
      await axios.delete(`${config.LOGITRAC_API_URL}api/config/sanddrive-review-app`)
      setInput('')
      setCurrentReviewApp(null)
      // Call the callback to update the banner
      if (onConfigUpdate) {
        onConfigUpdate()
      }
      handleClose()
    } catch (error) {
      console.error('Failed to clear review app:', error)
      console.error('Failed to clear SandDrive URL')
    } finally {
      setLoading(false)
    }
  }

  const handleUseDevStaging = async () => {
    const devStagingUrl = 'https://sanddrive.dev.tssands.com/'
    setLoading(true)
    try {
      await axios.post(
        `${config.LOGITRAC_API_URL}api/config/sanddrive-review-app`, 
        { url: devStagingUrl }
      )
      // Call the callback to update the banner
      if (onConfigUpdate) {
        onConfigUpdate()
      }
      handleClose()
    } catch (error) {
      console.error('Failed to set dev/staging URL:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Grid container className="GridContainer">
      {currentReviewApp && (
        <Grid item xs={12}>
          <Alert severity="info">Current: {currentReviewApp.url}</Alert>
        </Grid>
      )}

      <Grid item xs={12}>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Enter a review app number (e.g., 17246) or full URL (e.g., http://localhost:4000/)
        </Typography>
      </Grid>

      <Grid item xs={12} className="GridItem">
        <TextField
          id="sanddriveUrl"
          label="Review App Number or URL"
          helperText="Just the number (17246) or full URL"
          value={input}
          onChange={e => setInput(e.target.value)}
          margin="normal"
          fullWidth
        />
      </Grid>

      {previewUrl && previewUrl !== input && (
        <Grid item xs={12}>
          <Alert severity="success">Will set to: {previewUrl}</Alert>
        </Grid>
      )}

      <Grid item xs={12} style={{ marginTop: 20 }}>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={loading || !input}
        >
          {loading ? 'Setting...' : 'Set URL'}
        </Button>
        <Button 
          color="primary" 
          variant="outlined"
          onClick={handleUseDevStaging} 
          disabled={loading} 
          style={{ marginLeft: 10 }}
        >
          Use Dev/Staging
        </Button>
        <Button color="secondary" onClick={handleClear} disabled={loading} style={{ marginLeft: 10 }}>
          Clear
        </Button>
        <Button color="default" onClick={handleClose} style={{ marginLeft: 10 }}>
          Cancel
        </Button>
      </Grid>
    </Grid>
  )
}

export default SandDriveReviewApp
